import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Button,
  Typography,
  Divider,
  Card,
  Avatar,
  Space,
  Image,
} from "antd";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";
import Jiggle from "@assets/KPMG/Jiggle.svg";
import Symtric from "@assets/KPMG/Symtric.svg";
import WishHelp from "@assets/KPMG/WishHelp.svg";
import Resecurb from "@assets/KPMG/Resecurb.svg";
import Welytics from "@assets/KPMG/Welytics.svg";
import oracle from "@assets/KPMG/oracle.svg";
import Morphus from "@assets/KPMG/Morphus.svg";
import styles from "../Team/Team.module.scss";
import { Icon } from "@iconify/react";
import { Navigation, Pagination, A11y, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Fade } from "react-awesome-reveal";
import ConnectingDots from "@assets/KPMG/connectingDots.svg";
import CircleInCircle from "@assets/KPMG/circleInCircle.svg";
import DjuandaWater from "@assets/KPMG/assets/DjuandaWater.png";
import BinhDuong from "@assets/KPMG/assets/BinhDuong.png";
import plant from "@assets/KPMG/assets/plant.png";
import reserve from "@assets/KPMG/assets/reserve.png";
import { ProjectsCard } from "~/Components/ProjectsCard/ProjectsCard";

const getRandomImage = () => {
  const images = [DjuandaWater, BinhDuong, plant, reserve];
  const randomIndex = Math.floor(Math.random() * images.length);
  return images[randomIndex];
};
const RelatedProjects = (props: any) => {
  const { element, logos } = props;

  const cardsPerPage = 6;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(logos.length);
  const [visibleData, setVisibleData] = useState<any>([]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * cardsPerPage;
    const endIndex = startIndex + cardsPerPage;
    const currentData = logos.slice(startIndex, endIndex);
    setVisibleData(currentData);
  }, [currentPage]);

  return (
    <>
      <Fade direction="left" triggerOnce>
        <Row className="meet-our-team">
          <Col md={2}></Col>
          {/* <Col md={2} style={{ display: 'flex', textAlign: 'center', alignItems: 'center' }}>{element}</Col> */}
          <Col md={20}>
            <Row
              gutter={[16, 16]}
              justify="center"
              align="middle"
              style={{ padding: "20px 0" }}
            >
              <Swiper
                // install Swiper modules
                modules={[Navigation, Pagination, A11y, Autoplay]}
                spaceBetween={50}
                slidesPerView={3}
                navigation
                // pagination={{ clickable: true }}
                scrollbar={{ draggable: true }}
                autoplay={{
                  delay: 4000,
                  pauseOnMouseEnter: true,
                }}
              // onSwiper={(swiper) => console.log(swiper)}
              // onSlideChange={() => console.log("slide change")}
              >
                {logos.map((item: any, index: any) => (
                  <Col key={`related-${index}`}>
                    <SwiperSlide>
                      <ProjectsCard data={item} index={index} color />
                    </SwiperSlide>
                  </Col>
                ))}
              </Swiper>
            </Row>
          </Col>
          <Col md={2}></Col>
        </Row>
      </Fade>
    </>
  );
};

export default RelatedProjects;
